















import { Component, Vue, Prop } from 'vue-property-decorator';
import Divider from '@/components/common/Divider.vue';

export interface ToggleOption {
  id: string;
  value: string;
  isSelected?: boolean;
}

@Component({
  components: {
    Divider,
  },
})
export default class Toggle extends Vue {
  @Prop({ required: true })
  options!: ToggleOption[];

  @Prop()
  updateToggle!: (index: number) => void;

  @Prop({ default: 0 })
  initalSelected!: number;

  created() {
    this.resetAllOptions();
    const selectedOption = this.options[this.initalSelected];
    if (selectedOption) {
      selectedOption.isSelected = true;
    }
  }

  optionClick(index: number) {
    this.resetAllOptions();

    const selectedOption = this.options[index];
    selectedOption.isSelected = true;
    this.$forceUpdate();
    this.updateToggle(index);
  }

  resetAllOptions() {
    this.options.forEach(option => {
      option.isSelected = false;
    });
  }
}
